"use strict";const t=()=>({styleOverrides:{list:{paddingTop:0,paddingBottom:0}}});module.exports=t;
